import React, { useEffect, useState } from 'react'

import { Button, Card, Form, Row, Typography, Icon, notification, Modal } from 'antd'
import { Formik } from 'formik'

import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { RULES, validRule } from '../../constants/Entitlements'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { getMessage } from '../../util/IntlMessages'
import CustomInput from '../../components/CustomInput/customInput'
import { api, request } from '../../util/handlerRequestUtil'
import { CATEGORY_VALIDATION_SCHEMA } from './CategoryValidation'
import AlertIcon from '../../assets/images/ico_erro.svg'

const CreateCategory = ({ match, history }) => {
  const [category, setCategory] = useState({ active: true })
  const { id } = match.params
  const { confirm } = Modal

  useEffect(() => {
    if (id) {
      fetchCategory()
    }
  }, [id])

  async function fetchCategory() {
    const category = await request(api.getCategory(id))
    setCategory({ ...category })
  }

  async function createCategory(payload) {
    await request(api.createCategory(payload))
    notification.success({
      description: getMessage('successStoreCategory'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function updateCategory(id, payload) {
    if (!payload.active) {
      await showConfirm(async () => {
        await request(api.updateCategory(id, payload))
      }, `Ao inativar a categoria, todas as ações relacionadas também serão inativadas. Tem certeza que deseja seguir?`)
    } else {
      await request(api.updateCategory(id, payload))
      notification.success({
        description: getMessage('successUpdateCategory'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    }
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 20
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
            .then(
              notification.success({
                description: getMessage('successUpdateCategory'),
                message: getMessage('sweetAlerts.success')
              })
            )
            .then(history.goBack())
        }
      },
      onCancel() {}
    })
  }

  async function onSubmit(values) {
    const payload = { ...values }
    if (!id) {
      await createCategory(payload).then(() => history.goBack())
    } else {
      await updateCategory(id, {
        name: payload.name,
        proposito: payload.proposito,
        active: payload.active
      })
    }
  }

  function renderHeader(submitForm) {
    const hasAccess = id ? validRule(RULES.CATEGORY) : validRule(RULES.CATEGORY)
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={submitForm}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function renderTitle() {
    return id !== null ? getMessage('updateCategories') : getMessage('createCategories')
  }

  return (
    <Formik
      enableReinitialize
      validationSchema={CATEGORY_VALIDATION_SCHEMA}
      initialValues={category}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, submitForm, handleSubmit, handleBlur, setFieldValue }) => {
        return (
          <Form layout="vertical" onSubmit={handleSubmit}>
            {renderHeader(submitForm)}

            <Card className="ant-card gx-card ant-card-bordered">
              <Typography.Title className="default-header-title" level={3}>
                {renderTitle()}
                <Row
                  type="flex"
                  justify="start"
                  style={{ flexDirection: 'column', float: 'right', padding: '0px', margin: '0px' }}
                >
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValue}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                  />
                </Row>
              </Typography.Title>
              <Row type="flex" style={{ flexDirection: 'column', marginTop: '10px' }}>
                <CustomInput
                  label="nome"
                  field="name"
                  errors={errors}
                  placeholder="Digite aqui"
                  setFieldValue={setFieldValue}
                  rowSpan={10}
                  value={values}
                  handleBlur={handleBlur}
                  required
                />
                <CustomInput
                  field="proposito"
                  errors={errors}
                  placeholder="Digite aqui"
                  setFieldValue={setFieldValue}
                  value={values}
                  handleBlur={handleBlur}
                  required
                />
              </Row>
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CreateCategory
